/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useReduxData from "../../../Hooks/useReduxData";
import { toast } from "react-toastify";
import { ageGroups, medicines, RoleTitle, } from "../../../Context/constants";
import { useFormik } from "formik";
import { addNewTestsValidation, medicineValidation, treatmentPlanValidation } from "../../../Context/Validation";
import { ADD_TREATMENT_PLAN, ARCHIVE_TREATMENT_PLAN, INSERT_MEDICINE, MEDICINE_LIST, TREATMENT_PLAN_LIST, UPDATE_TREATMENT_PLAN, } from "../../Repository/SettingRepo";
import { INSERT_SETUP, SETUP_LIST } from "../../Repository/AppointmentsRepo";

const useTreatmentPlan = () => {
    const [loader, setLoader] = useState(false)
    const [TotalCount, setTotalCount] = useState(0)
    const [formNumber, setFormNumber] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });
    const [treatmentPlanList, setTreatmentPlanList] = useState([])
    const [testReport, setTestReport] = useState([])
    const [medicineList, setMedicineList] = useState([])
    const [Filter, setFilter] = useState({
        archive: true,
        search: "",
        disable_button: true
    })
    const [openModal, setOpenModal] = useState({
        add: false,
        archive: false,
        tests: false,
        view: false,
        addMedicine: false,
        data: null,
        previoursData: null
    })
    const navigate = useNavigate()
    const { reduxData: userdata } = useReduxData("userDataRDX")

    const headCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "name", numeric: true, disablePadding: false, label: "Name", isShorted: true },
        { id: "abbr", numeric: true, disablePadding: false, label: "Plan Type", isShorted: true },
        { id: "brandName", numeric: true, disablePadding: false, label: "Age Group", isShorted: true },
        { id: "brandName", numeric: true, disablePadding: false, label: "Test", isShorted: true },
        { id: "medicineType", numeric: true, disablePadding: false, label: "Created Date", isShorted: true },
        { id: "Strength", numeric: true, disablePadding: false, label: "Updated Date", isShorted: true },
        { id: "action", numeric: false, disablePadding: false, showLeft: true, label: "Action", isShorted: false },
    ];
    const ViewHeadCells = [

        { id: "#", numeric: true, disablePadding: false, label: "#", showIcon: true },
        { id: "Medicine", numeric: true, disablePadding: false, label: "Medicine", showIcon: true },
        { id: "medicineType", numeric: true, disablePadding: false, label: "Medicine type", showIcon: true },
        { id: "Dose", numeric: true, disablePadding: false, label: "Standard", showIcon: true },
        { id: "Strength", numeric: true, disablePadding: false, label: "Strength", showIcon: true },
        { id: "Duration", numeric: true, disablePadding: false, label: "Duration", showIcon: true },
        { id: "medicineIntakeTime", numeric: true, disablePadding: false, label: "Dosage Instructions", showIcon: true },
        { id: "Qty", numeric: true, disablePadding: false, label: "Qty", showIcon: true },
    ];

    async function getTreatmentPlanList() {
        setLoader(true)
        const { page, rowsPerPage, searchPage } = controller;
        const { archive, search } = Filter;
        const keyword = search.trim();
        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            page: page,
            count: rowsPerPage,
            activeStatus: archive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
            roleTitle: userdata.roleTitle
        };
        try {
            let response = await TREATMENT_PLAN_LIST(payload)
            setTreatmentPlanList(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setTreatmentPlanList([])
            setTotalCount(0)
            setLoader(false)
        }
    }

    async function getMedicineList() {
        setLoader(true);
        const payload = {
            activeStatus: true,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await MEDICINE_LIST(payload)
            setMedicineList(response?.data?.map((cur) => ({ ...cur, medicine: `${cur?.name} (${cur?.dose} ${cur?.unit}) - ${cur?.medicineType} (${cur?.brandName})` })));
            setLoader(false)
        } catch (error) {
            setMedicineList([])
            setLoader(false)
        }
    }

    async function getRestReportList(testIds) {
        const payload = {
            activeStatus: true,
            providerId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.providerId : userdata?.userId,
            staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            type: "TEST",
        };
        try {
            let response = await SETUP_LIST(payload)
            const testData = response?.data || [];
            setTestReport(testData);
            if (testIds?.length) {
                const tests = testData.filter((cur) => testIds.some((item) => item?.testsName === cur?.name));
                formik.setFieldValue("tests", tests)
            }
        } catch (error) {
            setTestReport([])
        }
    }

    const formik = useFormik({
        initialValues: {
            name: "",
            followUp: "",
            planType: "",
            planTypeField: "",
            tests: [],
            ageGroup: [],
            medicines: [
                { ...medicines }
            ],
        },
        validationSchema: treatmentPlanValidation,
        onSubmit: async (values, { resetForm }) => {
            const { clone, ...restValue } = values
            let payload = {
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
                frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                treatmentPlanId: (openModal?.data && !clone) ? openModal?.data?.id : undefined,
                roleTitle: userdata.roleTitle,
                name: restValue?.name,
                followUp: restValue?.followUp,
                planType: restValue?.planType,
                planTypeField: restValue?.planType === "Others" ? restValue?.planTypeField : undefined,
                tests: restValue?.tests?.map((cur) => cur?.name),
                ageGroup: restValue?.ageGroup?.map((cur) => cur?.value),
                rx: restValue?.medicines?.map((cur) => ({
                    ...cur,
                    medicineId: cur?.medicine[0]?.medicineId,
                    customMedCount: cur?.timeofmedicine === "HOURS" ? cur?.timeofmedicinenumberForHours : cur?.timeofmedicinenumberForDays,
                    customMedCountTimeFrame: cur?.medCountType === "STANDARD" ? null : cur?.timeofmedicine,
                    timeofmedicine: undefined,
                    timeofmedicinenumberForDays: undefined,
                    timeofmedicinenumberForHours: undefined,

                })),
            }
            setLoader(true)
            console.log(clone, "clone")
            try {
                let response = (openModal?.data && !clone) ? await UPDATE_TREATMENT_PLAN(payload) : await ADD_TREATMENT_PLAN(payload)
                resetForm()
                toast.success(response?.message)
                handleClosedModal("add", true)
                setFormNumber(0)
                setLoader(false)
                await getTreatmentPlanList()
            } catch (error) {
                toast.error(error?.message)
                setLoader(false)
            }
        },
    });

    const handleAddMedicine = useFormik({
        initialValues: {
            name: "",
            reaction: "",
            unit: "",
            dose: "",
            medicineType: "",
            brandName: "",
            abbr: ""
        },
        validationSchema: medicineValidation,
        onSubmit: async (values, { resetForm }) => {
            const { clone, ...restValue } = values
            setLoader(true)
            let payload = {
                providerId: openModal?.data ? undefined : (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
                frontdeskId: openModal?.data ? undefined : userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                roleTitle: openModal?.data ? undefined : userdata.roleTitle,
                ...restValue,
            }
            try {
                let response = await INSERT_MEDICINE(payload)
                await getMedicineList()
                toast.success(response.message)
                setLoader(false)
                handleClosedModal("addMedicine")
                handleOpenModal("add", openModal?.previoursData)
                resetForm()
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })
    const newAddTestsRequested = useFormik({
        initialValues: {
            Tests: ""
        },
        validationSchema: addNewTestsValidation,
        onSubmit: async (values, { resetForm }) => {
            let payload = {
                name: values?.Tests,
                type: "TEST",
                providerId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.providerId : userdata?.userId,
                staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            }
            try {
                let response = await INSERT_SETUP(payload)
                toast.success(response.message)
                setLoader(false)
                handleClosedModal("tests")
                handleOpenModal("add", openModal?.previoursData)
                await getRestReportList()
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
            resetForm()
        }
    })


    const getDetails = (data) => {
        if (!data) return;

        const testDetails = ageGroups?.filter((cur) => cur?.value === data?.ageGroup)

        let treatmentPlanDetails = {
            clone: data?.clone ? data?.clone : undefined,
            name: data?.name || "",
            followUp: data?.followUp || "",
            planType: data?.planType || "",
            planTypeField: data?.planTypeField || "",
            ageGroup: testDetails,
            medicines: data?.rx?.map((cur) => {
                const medicine = medicineList.filter((item) => item?.medicineId === cur?.medicineId) || [];
                return {
                    medicine: medicine,
                    medCountType: cur?.medicineIntakeType || "",
                    timeofmedicine: cur?.customMedCountTimeFrame || "",
                    timeofmedicinenumberForHours: (cur?.customMedCountTimeFrame === "HOURS") ? (cur?.customMedCount || "") : "",
                    timeofmedicinenumberForDays: cur?.customMedCountTimeFrame !== "HOURS" ? (cur?.customMedCount || "") : "",
                    morningMedCount: cur?.medicineIntakeMorning,
                    afternoonMedCount: cur?.medicineIntakeAfternoon,
                    nightMedCount: cur?.medicineIntakeEvening,
                    duration: cur?.medicineIntakeDurationAmount || "",
                    durationTimeFrame: cur?.medicineIntakeDurationType || "",
                    quantity: cur?.medicineIntakeAmount || "",
                    when: cur?.medicineIntakeTime || "",
                    whenCustom: cur?.medicineIntakeCustomTime || "",
                    notes: cur?.notes || "",
                    prescriptionId: cur?.prescriptionId || undefined,
                    staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
                    providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
                    frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                }
            })
        }
        formik.setValues(treatmentPlanDetails)
    }

    const handleOpenModal = (type, data = null) => {
        if (type === "add") {
            getRestReportList(data?.tests)
            if (data) {
                getDetails(data)
            }
        }
        setOpenModal((prev) => ({
            ...prev,
            data: data,
            previoursData: data,
            [type]: true,
        }));
    };
    const handleClosedModal = (type, isNull) => {
        if (type === "tests") {
            newAddTestsRequested.resetForm()
        }
        setOpenModal((pre) => ({
            ...pre,
            data: null,
            previoursData: isNull ? null : pre?.previoursData,
            [type]: false
        }))
    }
    const archiveUnarchive = async (event) => {
        if (event === "YES") {
            setLoader(true)
            let payload = {
                treatmentPlanId: openModal?.data?.id,
                activeStatus: !openModal?.data?.activeStatus
            }
            try {
                let response = await ARCHIVE_TREATMENT_PLAN(payload)
                toast.success(response.message)
                if (treatmentPlanList?.length === 1 && controller.page === 1) {
                    getTreatmentPlanList()
                }
                else if (treatmentPlanList?.length === 1) {
                    setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
                } else getTreatmentPlanList()
                setLoader(false)
                handleClosedModal("archive")
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        } else {
            handleClosedModal("archive")
        }

    }

    const handleChangeFilter = (event) => {
        const { name, value } = event.target
        setFilter((pre) => ({ ...pre, disable_button: false, [name]: value }))
    }
    const HandleSearchList = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    const reset = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }))
        setFilter({ archive: true, search: "", disable_button: true })
    }

    useEffect(() => {
        getTreatmentPlanList()
        navigate({ replace: true, state: null })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller])
    useEffect(() => {
        getMedicineList()
    }, [])


    return {
        data: {
            headCells,
            controller,
            Filter,
            TotalCount,
            treatmentPlanList,
            loader,
            openModal,
            formik,
            medicineList,
            testReport,
            formNumber,
            ViewHeadCells,
        },
        methods: {
            handleChangeFilter,
            HandleSearchList,
            handleOpenModal,
            handleClosedModal,
            setController,
            reset,
            archiveUnarchive,
            setFormNumber,
            newAddTestsRequested,
            handleAddMedicine

        }
    }
}

export default useTreatmentPlan
